<template>
    <div class="fb-messenger bg-white py-8 px-9">
        <div
            class="btn-fb-messenger w-full outline-none flex items-center justify-center"
            @click="openFb()"
        >
            <img src="@/assets/icon/misc/fb-messenger.svg" class="mr-4 align-middle" alt />
            <span class="text-white">{{ text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ButtonFBMessenger",
    props: {
        text: String
    },
    methods: {
        openFb: function () {
            this.setTracking();
            window.location = 'https://www.facebook.com/JCBCardThailandTH/'
        },
        setTracking: function(){
            var currentPath = this.$route.path;
            if(currentPath.indexOf('faq') > 0 ||
                currentPath.indexOf('faq-detail') > 0){
                this.tracking.event('more_question', 'click_more_question', null, null);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-fb-messenger {
    height: 55px;
    background: url("~@/assets/button/btn-fb-messenger.svg");
    background-size: 100% 100%;

    img {
        display: inline-block;
    }
}
</style>
